import type { DelayedQuote } from '@benzinga/quotes-manager';
import { toProtobufNumber, type Quote } from '@benzinga/quotes-v3-manager';

export const REALTIME_QUOTE_STALE_BUFFER_MS = 60_000;

export const isRealtimeQuoteStale = (
  quote: Pick<Quote, 'lastTradeTime' | 'time'> | null | undefined,
  delayed: Pick<DelayedQuote, 'lastTradeTime'> | null | undefined,
): boolean => {
  const liveTime = toProtobufNumber(quote?.lastTradeTime ?? quote?.time);
  const delayedTime = delayed?.lastTradeTime;
  if (!liveTime || !delayedTime) return false;
  return liveTime < delayedTime - REALTIME_QUOTE_STALE_BUFFER_MS;
};
